import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {
    generate
} from '@/helpers/pdf';

const _getHead = () => ['FUNCIONÁRIO', 'EFETIVADOS', 'NEGATIVADOS', 'TOTAL'];

const _getBody = data => {
    const info = {
        name: '',
        list: []
    };
    data.itens.forEach(item => {
        info.name = data.name;
        info.list.push([item['Funcionário'], item['Efetivados'], item['Negativados'], item['Total']])
    });

    return info;
}
const download = (data, meta) => {
    const infosTmp = _getBody(data);
    const infos = {
        head: [_getHead()],
        body: infosTmp.list,
        title: `Relatório Empresa Parceira - ${infosTmp.name}`,
        subTitle: meta.subTitle
    };
    generate(infos, {
        fileName: meta.fileName
    });
}
export {
    download
};


// WEBPACK FOOTER //
// ./src/pdf/EmpresasParceiras.js